export default __webpack_public_path__ + "static/media/chef.abcae361.png";